module.exports = __webpack_public_path__ + "static/media/beliefs-large@3x.b629f785.png";